// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormFieldClickable } from "@awc/MobiusOverrides/FormField";
import Search from "@awc/XDL/Icons/Search";
import { searchBoxStyles } from "@insite/content-library/Widgets/Addresses/AddressBookSearchBox";
import { css } from "styled-components";

searchBoxStyles.searchText = {
    mergeCss: true,
    iconProps: { src: Search },
    cssOverrides: {
        formField: css`
            max-width: 430px;
        `,
        formInputWrapper: css`
            ${FormFieldClickable} {
                right: 20px;
            }
        `,
    },
};
